import {PolicyFragment} from '../../../../gql/graphql';
import {DEFAULT_ITEM_POLICY} from '../../../../components/Checkout/constants';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class PolicyModel {
  public title: string;
  public content?: string;

  constructor(params: PolicyModel) {
    this.title = params.title;
    this.content = params.content;
  }

  public static fromCheckoutV1(policy?: PolicyFragment | null) {
    return new PolicyModel({
      title: policy?.title && policy?.title !== '' ? policy?.title : DEFAULT_ITEM_POLICY,
      content: mapNullToUndefined(policy?.content),
    });
  }
}
